/* ==========================================================
   Jé Vue · Pre-launch threshold behaviour (Shopify)
   - Its own once-per-session entrance (key: jevue_threshold_seen).
     It never touches the main entrance's key.
   - Any key, click, tap or scroll skips straight to the ways in.
   - The real password is checked by Shopify; this only opens the form
     and keeps it open (with its message) after a wrong password.
   ========================================================== */
(function(){
'use strict';
const $ = s => document.querySelector(s);
const html = document.documentElement;
const KEY = 'jevue_threshold_seen';
const STEPS = { mark:700, tag:1900, eye:3000, door:3200, status:4900, actions:5900, done:6900 };
const eye = window.JVHouseEye || { start: () => Promise.resolve(false), setActive(){} };
const LIVE = !!(window.__JV && window.__JV.liveForms);
let timers = [];

// After a wrong password or a sign-up, show the page at rest with the result in view.
const wrongPw = !!$('[data-pw-error]');
const posted = /[?&]customer_posted=true\b/.test(location.search) || !!($('#pw-email-msg') && $('#pw-email-msg').textContent.trim());
if (wrongPw || posted) html.setAttribute('data-pw', 'done');

function on(k){ document.querySelectorAll('[data-pw-step="' + k + '"]').forEach(el => el.classList.add('is-on')); }
function finish(){ timers.forEach(clearTimeout); timers = []; html.setAttribute('data-pw', 'done'); html.classList.remove('pw-fast'); unlisten(); }
function skip(){
  if (html.getAttribute('data-pw') !== 'run') return;
  timers.forEach(clearTimeout); timers = [];
  html.classList.add('pw-fast'); Object.keys(STEPS).forEach(on); eye.setActive(true);
  timers.push(setTimeout(finish, 520));
}
const EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
function listen(){ EVENTS.forEach(e => addEventListener(e, skip, { capture:true, passive:true })); }
function unlisten(){ EVENTS.forEach(e => removeEventListener(e, skip, { capture:true, passive:true })); }

eye.start();
if (html.getAttribute('data-pw') === 'pre'){
  try { sessionStorage.setItem(KEY, '1'); } catch(e){}
  html.setAttribute('data-pw', 'run'); listen();
  ['mark','tag','eye','door','status','actions'].forEach(k => timers.push(setTimeout(() => on(k), STEPS[k])));
  timers.push(setTimeout(() => eye.setActive(true), STEPS.eye + 2600));
  timers.push(setTimeout(finish, STEPS.done));
} else {
  eye.setActive(true);
}

/* Opening notice */
const ok = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
const signup = $('.pw-signup');
if (signup){
  signup.noValidate = true;
  signup.addEventListener('submit', e => {
    const i = $('#pw-email'), m = $('#pw-email-msg'), v = i.value.trim();
    if (!ok(v)){ e.preventDefault(); i.setAttribute('aria-invalid', 'true'); m.classList.add('is-error'); m.textContent = v ? 'Please enter a valid email address.' : 'Please enter your email address.'; i.focus(); return; }
    i.removeAttribute('aria-invalid'); m.classList.remove('is-error');
    if (!LIVE){
      e.preventDefault(); i.value = '';
      m.textContent = 'Sign-ups are not open yet, so your address was not saved.';
    }
  });
}

/* Enter with password */
const toggle = $('.pw-enter__toggle'), wrap = $('#pw-form-wrap'), form = $('#pw-form'), pass = $('#pw-pass'), err = $('#pw-pass-err');
function openForm(focus){ wrap.hidden = false; toggle.setAttribute('aria-expanded', 'true'); if (focus) setTimeout(() => { pass.focus(); if (wrongPw) pass.select(); }, 30); }
toggle.addEventListener('click', () => {
  if (wrap.hidden) openForm(true); else { wrap.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
});
wrap.addEventListener('keydown', e => { if (e.key === 'Escape'){ wrap.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); } });
form.noValidate = true;
form.addEventListener('submit', e => {
  if (!pass.value){ e.preventDefault(); pass.setAttribute('aria-invalid', 'true'); err.textContent = 'Please enter the password.'; pass.focus(); return; }
  if (form.hasAttribute('data-pw-preview')){
    e.preventDefault(); err.textContent = 'Owner preview: the password is checked only on the real password page.';
  }
});
if (wrongPw) openForm(true);
})();
